module.exports = __webpack_public_path__ + "static/media/arrow_down.723e6fc6.svg";